import { Field } from '#app/components/form/field.tsx'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type Props = {
	readonly resources: SectionResources
	readonly artworkSystem: string
	readonly approvalOwner: string
	readonly artworkSystemErrors: readonly string[]
	readonly approvalOwnerErrors: readonly string[]
	readonly onArtworkSystemChange: (value: string) => void
	readonly onApprovalOwnerChange: (value: string) => void
}

export function ArtworkControlSection({
	resources,
	artworkSystem,
	approvalOwner,
	artworkSystemErrors,
	approvalOwnerErrors,
	onArtworkSystemChange,
	onApprovalOwnerChange,
}: Props) {
	return (
		<Section
			title="Artwork control"
			description="Explain where masters live and who has the authority to approve changes before print or publication."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
			childrenClassName="space-y-6"
		>
			<Field
				labelProps={{
					children: 'Where are artwork masters stored and version-controlled?',
				}}
				inputProps={{
					name: 'artworkSystem',
					value: artworkSystem,
					onChange: (event) => onArtworkSystemChange(event.target.value),
					type: 'text',
				}}
				descriptionProps={{
					children:
						'Mention systems like Esko, Filestage, Figma, or shared drives, plus any permissions safeguards.',
				}}
				errors={
					artworkSystemErrors.length > 0 ? [...artworkSystemErrors] : undefined
				}
			/>
			<Field
				labelProps={{
					children: 'Who signs off on label changes before release?',
				}}
				inputProps={{
					name: 'approvalOwner',
					value: approvalOwner,
					onChange: (event) => onApprovalOwnerChange(event.target.value),
					type: 'text',
				}}
				descriptionProps={{
					children:
						'Name the role (e.g., Regulatory lead, VP Marketing) so we can reference the approval authority in the SOP.',
				}}
				errors={
					approvalOwnerErrors.length > 0 ? [...approvalOwnerErrors] : undefined
				}
			/>
		</Section>
	)
}
